export const colorCategories = [
  {
    id: 'played_games',
    name: 'Played games'
  },
  {
    id: 'victories',
    name: 'Victories'
  },
  {
    id: 'points',
    name: 'Points'
  },
  {
    id: 'goals_scored',
    name: 'Goals scored'
  },
  {
    id: 'goals_conceded',
    name: 'Goals conceded'
  }
];
